import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import './LandingNavbar.css';

function slugify(str) {
  return str.toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9\s-]/g,'').trim().replace(/\s+/g,'-').replace(/-+/g,'-');
}

export default function LandingNavbar() {
  const navigate = useNavigate();
  const navbarRef = useRef(null);
  const closeTimer = useRef(null);
  const progTimer = useRef(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showSignInDropdown, setShowSignInDropdown] = useState(false);
  const [showProgMenu, setShowProgMenu] = useState(false);
  const [programmes, setProgrammes] = useState([]);

  useEffect(() => {
    const addLink = (href) => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const el = document.createElement('link');
        el.rel = 'stylesheet'; el.href = href;
        document.head.appendChild(el);
      }
    };
    addLink('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
    addLink('https://cdn.jsdelivr.net/npm/remixicon@4.0.0/fonts/remixicon.css');

    const onScroll = () => {
      if (navbarRef.current) navbarRef.current.classList.toggle('hu-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    api.get('/academic/programmes/public').then(r => setProgrammes(r.data)).catch(() => {});

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const openProg = () => { clearTimeout(progTimer.current); setShowProgMenu(true); };
  const closeProg = () => { progTimer.current = setTimeout(() => setShowProgMenu(false), 200); };
  const openSignIn = () => { clearTimeout(closeTimer.current); setShowSignInDropdown(true); };
  const closeSignIn = () => { closeTimer.current = setTimeout(() => setShowSignInDropdown(false), 200); };

  return (
    <div className="hu-lnav-ctx">
      {/* Mobile Menu */}
      <div className={`hu-mobile-menu${mobileOpen ? ' hu-open' : ''}`}>
        <button className="hu-mobile-close" onClick={() => setMobileOpen(false)}><i className="ri-close-line" /></button>
        <a href="/#features" onClick={() => setMobileOpen(false)}>Features</a>
        <a href="/#how-it-works" onClick={() => setMobileOpen(false)}>How It Works</a>
        <a href="/#programmes" onClick={() => setMobileOpen(false)}>Programmes</a>
        <a href="/programmes" onClick={() => setMobileOpen(false)}>All Programmes</a>
        <a href="https://panel.homeunilearn.com/auth/login" target="_blank" rel="noopener noreferrer"
           onClick={() => setMobileOpen(false)} style={{fontSize:'1.1rem'}}>
          <i className="ri-briefcase-4-line" style={{marginRight:'.5rem'}} /> Login as Staff
        </a>
        <a href="https://homeunilearn.com/auth/login" target="_blank" rel="noopener noreferrer"
           onClick={() => setMobileOpen(false)}
           style={{marginTop:'1rem',background:'#C9A84C',color:'#FFF',padding:'.9rem 2.25rem',borderRadius:14,fontWeight:600,fontSize:'1rem',display:'inline-flex',alignItems:'center',gap:'.5rem'}}>
          <i className="ri-graduation-cap-line" /> Login as Student
        </a>
      </div>

      {/* Navbar */}
      <nav className="hu-navbar" ref={navbarRef}>
        <div className="hu-container">
          <div className="hu-navbar__inner">
            <a href="/" className="hu-navbar__logo">
              <img src="/main-logo-horinzontal.png" alt="HomeUni Logo"
                style={{height:'48px',width:'auto',objectFit:'contain',filter:'drop-shadow(0 2px 8px rgba(21,101,192,0.2))'}} />
              <span className="hu-navbar__logo-divider" />
              <img src="/ugc_logo.png" alt="UGC"
                style={{height:'36px',width:'auto',objectFit:'contain',filter:'brightness(0)',opacity:.75}} />
            </a>
            <ul className="hu-navbar__nav">
              <li><a href="/#features">Features</a></li>
              <li><a href="/#how-it-works">How It Works</a></li>
              <li
                className={`hu-nav-prog-wrap${showProgMenu ? ' prog-open' : ''}`}
                onMouseEnter={openProg}
                onMouseLeave={closeProg}
              >
                <a href="/#programmes">
                  Programmes <i className="ri-arrow-down-s-line" style={{fontSize:'.85rem'}} />
                </a>
                <div className="hu-prog-mega">
                  <div className="hu-prog-mega__inner">
                    <div className="hu-prog-mega__title">Available Programmes</div>
                    <div className="hu-prog-mega__grid">
                      {programmes.slice(0, 6).map((prog) => (
                        <a
                          key={prog.programme_id}
                          className="hu-prog-mega__item"
                          href={`/programmes/${slugify(prog.name)}`}
                          onMouseDown={e => { e.preventDefault(); navigate(`/programmes/${slugify(prog.name)}`); setShowProgMenu(false); }}
                        >
                          <div className="hu-prog-mega__name">{prog.name}</div>
                          <div className="hu-prog-mega__meta">{prog.level}{prog.price ? ` · GHS ${Number(prog.price).toLocaleString()}` : ''}</div>
                        </a>
                      ))}
                      {programmes.length === 0 && (
                        <div style={{gridColumn:'1/-1',padding:'.75rem',color:'#94A3B8',fontSize:'.875rem'}}>Loading programmes…</div>
                      )}
                    </div>
                    <div className="hu-prog-mega__footer">
                      <a href="/programmes" className="hu-prog-mega__all">Browse all programmes →</a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div className="hu-navbar__actions">
              <div
                className={`hu-sign-in-wrap${showSignInDropdown ? ' open' : ''}`}
                onMouseEnter={openSignIn}
                onMouseLeave={closeSignIn}
              >
                <button className="hu-btn hu-btn--ghost hu-btn--sm" onClick={() => setShowSignInDropdown(v => !v)}>
                  Sign In <i className="ri-arrow-down-s-line" />
                </button>
                <div className="hu-dropdown">
                  <div className="hu-dropdown__inner">
                    <a href="https://panel.homeunilearn.com/auth/login" target="_blank" rel="noopener noreferrer">
                      <i className="ri-briefcase-4-line" /> Login as Staff
                    </a>
                    <a href="https://homeunilearn.com/auth/login" target="_blank" rel="noopener noreferrer">
                      <i className="ri-graduation-cap-line" /> Login as Student
                    </a>
                  </div>
                </div>
              </div>
              <button className="hu-hamburger" onClick={() => setMobileOpen(true)}><i className="ri-menu-3-line" /></button>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
